import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { FileToUpload } from "../models/filetoupload";
import { ProfileImageUpload } from "../models/ProfileImageUpload";
import { AppConfig } from "../../app.config";
import { catchError } from "rxjs/Operators";

@Injectable({
  providedIn: "root",
})
export class FileUploadService {
  constructor(private http: HttpClient, private config: AppConfig) {}

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };
  private handleError(error: HttpErrorResponse) {
    return throwError(error.error);
  }

  profileUpload(theFile: any, fileAsBase64, empCode) {
    let file = new ProfileImageUpload();
    file.FileName = theFile[0].name;
    file.FileSize = theFile[0].size;
    file.FileType = theFile[0].type;
    file.LastModifiedTime = theFile[0].lastModified;
    file.LastModifiedDate = theFile[0].lastModifiedDate;
    file.FileAsBase64 = fileAsBase64;
    const ProfileFile = {
      ProfileFile: file,
      EmpCode: empCode,
    };
    return this.http
      .post(
        this.config.apiUrl + "HREmployeeApi/SaveBasicEmployeeProfile",
        ProfileFile,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  public readAndUploadProfilePic(theFile: any): ProfileImageUpload {
    let file = new ProfileImageUpload();
    file.FileName = theFile[0].name;
    file.FileSize = theFile[0].size;
    file.FileType = theFile[0].type;
    file.LastModifiedTime = theFile[0].lastModified;
    file.LastModifiedDate = theFile[0].lastModifiedDate;

    let reader = new FileReader();
    reader.onload = () => {
      file.FileAsBase64 = reader.result.toString();
    };
    reader.readAsDataURL(theFile[0]);
    return file;
  }

  public readAndUploadFile(theFile: any): FileToUpload {
    let file = new FileToUpload();
    // Set File Information
    file.fileName = theFile[0].name;
    file.fileSize = theFile[0].size;
    file.fileType = theFile[0].type;
    file.lastModifiedTime = theFile[0].lastModified;
    file.lastModifiedDate = theFile[0].lastModifiedDate;
    // Use FileReader() object to get file to upload
    // NOTE: FileReader only works with newer browsers
    let reader = new FileReader();
    // Setup onload event for reader
    reader.onload = () => {
      // Store base64 encoded representation of file
      file.fileAsBase64 = reader.result.toString();
    };
    // Read the file
    reader.readAsDataURL(theFile[0]);
    return file;
  }

  convertFileToFileToUpload(file: File): Promise<FileToUpload> {
    return new Promise((resolve, reject) => {
      const fileToUpload = new FileToUpload();

      fileToUpload.fileName = file.name;
      fileToUpload.fileSize = file.size;
      fileToUpload.fileType = file.type;
      fileToUpload.lastModifiedTime = file.lastModified;
      fileToUpload.lastModifiedDate = new Date(file.lastModified);
      const reader = new FileReader();

      reader.onload = () => {
        fileToUpload.fileAsBase64 = reader.result.toString();
        resolve(fileToUpload);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(file);
    });
  }

  uploadFile(theFile: FileToUpload) {
    return this.http
      .post(
        this.config.apiUrl + "OnboardingApi/Upload",
        theFile,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  getUserProfileDetails(empCode): Observable<any> {
    return this.http
      .get(
        `${this.config.apiUrl}HREmployeeApi/GetBasicEmployeeProfile?empCode=${empCode}`
      )
      .pipe(catchError(this.handleError));
  }

  async downloadImage(url: string, fileName) {
    fetch(url)
      .then((resp) => resp.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        // the filename you want
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => alert("An error sorry"));
  }
}
